import React from "react";
import { withRouter, Link, NavLink } from "react-router-dom";
import * as Icon from "react-feather";
import "./Navigation.css";
import {
  Navbar,
  Nav,
  NavDropdown,
  Form,
  FormControl,
  Button,
  Image,
} from "react-bootstrap";
import firebase from "../../Utils/Firebase";

import SideMenuLight from "./SideMenu/SideMenuLight";

// Logo image path
import Logo from "../../assets/img/logo.png";
import SmallLogo from "../../assets/img/small-logo.png";

class Navigation extends React.Component {
  state = {
    sideMenu: false,
    term: "",
    menuColor: false,
    loading: true,
  };

  _toggleClass = () => {
    const currentSideMenu = this.state.sideMenu;
    this.setState({ sideMenu: !currentSideMenu });
    // this.props.onClick(this.state.sideMenu);
  };

  onSideMenuHandler = (activeColor) => {
    this.setState({ menuColor: activeColor });
  };

  render() {
    return (
      <div className="page-wrapper">
        <Navbar fixed="top" className="top-menu">
          <Link
            to="/dashboard"
            className={`navbar-brand ${
              this.state.sideMenu ? "navbar-logo" : ""
            }`}
          >
            <Image
              style={{ width: 60 }}
              src={Logo}
              alt="Logo"
              className="large-logo"
            />
            <Image
              style={{ width: 60 }}
              src={SmallLogo}
              alt="Small Logo"
              className="small-logo"
            />
          </Link>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <div
            className={`burger-menu ${
              this.state.sideMenu ? "toggle-menu" : ""
            }`}
            onClick={this._toggleClass}
          >
            <span className="top-bar" />
            <span className="middle-bar" />
            <span className="bottom-bar" />
          </div>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="left-nav d-none d-md-block" />

            <Nav className="ml-auto right-nav">
              <NavDropdown
                title={<div className="menu-profile">Account</div>}
                id="basic-nav-dropdown"
                className="profile-nav-item"
              >
                <NavLink
                  to=""
                  onClick={() => firebase.auth().signOut()}
                  className="dropdown-item"
                >
                  <Icon.LogOut className="icon" />
                  Logout
                </NavLink>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        {<SideMenuLight sideMenu={this.state.sideMenu} />}
      </div>
    );
  }
}

export default withRouter(Navigation);
